import Tables from "./Tables";

export default function System() {
  return <Tables systemMode />;
}
